var map = {
	"./Anyswap.png": 510,
	"./Anyswap.svg": 511,
	"./Artwork.svg": 512,
	"./Artwork_gmx.svg": 513,
	"./Banxa.png": 514,
	"./DROP_DOWN.svg": 294,
	"./Hop.png": 515,
	"./Hop.svg": 516,
	"./Hop_dark.png": 517,
	"./Hop_dark.svg": 518,
	"./Synapse.png": 519,
	"./Synapse.svg": 520,
	"./binance.png": 521,
	"./bitkeep.svg": 522,
	"./bscscan.png": 523,
	"./btn_big_arbitrum.png": 524,
	"./btn_big_avalanche.png": 525,
	"./btn_big_bsc.png": 526,
	"./btn_big_purchasegmx.png": 527,
	"./btn_big_purchasegmx.svg": 528,
	"./buy_gmx.svg": 295,
	"./buy_gmx_bond.svg": 529,
	"./buy_transfer_eth.svg": 530,
	"./coinbaseWallet.png": 296,
	"./coingecko.png": 531,
	"./cross.svg": 532,
	"./flag_en.svg": 533,
	"./flag_es.svg": 534,
	"./flag_fr.svg": 535,
	"./flag_ja.svg": 536,
	"./flag_ko.svg": 537,
	"./flag_ru.svg": 538,
	"./flag_zh.svg": 539,
	"./gateio.svg": 540,
	"./glp_icon.svg": 541,
	"./gmx-logo-final-white-small.png": 542,
	"./gmx-logo-final-white.png": 543,
	"./gmx-logo-final.png": 544,
	"./gmx-logo-glow.png": 545,
	"./gmx-logo-with-name.svg": 297,
	"./gmx_logo.svg": 546,
	"./graphite-01.png": 547,
	"./ic-communityproject.svg": 548,
	"./ic_1inch.svg": 549,
	"./ic_across.svg": 550,
	"./ic_arbitrum_16.svg": 131,
	"./ic_arbitrum_24.svg": 244,
	"./ic_arbitrum_96.svg": 172,
	"./ic_arbitrum_hover_16.svg": 551,
	"./ic_arrowleft16.svg": 552,
	"./ic_arrowright16.svg": 553,
	"./ic_avalanche_16.svg": 132,
	"./ic_avalanche_24.svg": 245,
	"./ic_avalanche_96.svg": 173,
	"./ic_avalanche_testnet_16.svg": 554,
	"./ic_avalanche_testnet_24.svg": 555,
	"./ic_avalanche_testnet_96.svg": 556,
	"./ic_avax_24.svg": 557,
	"./ic_avax_30.svg": 558,
	"./ic_avax_40.svg": 559,
	"./ic_banxa.svg": 246,
	"./ic_binance.svg": 298,
	"./ic_binance_logo.svg": 560,
	"./ic_bsc.svg": 561,
	"./ic_bsc_96.svg": 562,
	"./ic_btc.b_24.svg": 563,
	"./ic_btc.b_40.svg": 564,
	"./ic_btc_24.svg": 565,
	"./ic_btc_40.svg": 566,
	"./ic_bungee.png": 247,
	"./ic_busd_24.svg": 567,
	"./ic_buy_glp.svg": 299,
	"./ic_bybit.svg": 568,
	"./ic_cash.png": 569,
	"./ic_cash.svg": 570,
	"./ic_checked.svg": 300,
	"./ic_coingecko_16.svg": 301,
	"./ic_coingecko_hover_16.svg": 571,
	"./ic_convert_down.svg": 302,
	"./ic_copy_16.svg": 303,
	"./ic_cost.svg": 304,
	"./ic_dai_24.svg": 572,
	"./ic_dai_40.svg": 573,
	"./ic_discord.svg": 574,
	"./ic_dodo.svg": 575,
	"./ic_eth_24.svg": 576,
	"./ic_eth_40.svg": 577,
	"./ic_firebird.png": 578,
	"./ic_frax_24.svg": 579,
	"./ic_frax_40.svg": 580,
	"./ic_fusd_40.svg": 581,
	"./ic_fuse_16.svg": 248,
	"./ic_fuse_24.svg": 363,
	"./ic_fuse_40.svg": 582,
	"./ic_fuse_96.svg": 583,
	"./ic_fuse_sparknet.svg": 584,
	"./ic_github.svg": 585,
	"./ic_glp_24.svg": 249,
	"./ic_glp_40.svg": 199,
	"./ic_glp_custom.svg": 305,
	"./ic_gmx.svg": 586,
	"./ic_gmx_24.svg": 587,
	"./ic_gmx_30.svg": 588,
	"./ic_gmx_40.svg": 306,
	"./ic_gmx_64.svg": 589,
	"./ic_gmx_arbitrum.svg": 590,
	"./ic_gmx_avax.svg": 591,
	"./ic_gmx_big.svg": 592,
	"./ic_gmx_custom.svg": 307,
	"./ic_gmx_footer.svg": 593,
	"./ic_hop.svg": 594,
	"./ic_huobi.svg": 595,
	"./ic_info.svg": 596,
	"./ic_kucoin.svg": 597,
	"./ic_language24.svg": 200,
	"./ic_link_24.svg": 598,
	"./ic_link_40.svg": 599,
	"./ic_liquidity.svg": 308,
	"./ic_matcha.png": 600,
	"./ic_medium.svg": 309,
	"./ic_menu_dots.svg": 601,
	"./ic_metamask_16.svg": 310,
	"./ic_metamask_hover_16.svg": 602,
	"./ic_mim_24.svg": 603,
	"./ic_mim_40.svg": 604,
	"./ic_multiswap.svg": 605,
	"./ic_new_link_16.svg": 311,
	"./ic_o3.png": 250,
	"./ic_odos.png": 606,
	"./ic_olympus.svg": 607,
	"./ic_olympus_arbitrum.svg": 312,
	"./ic_openocean.svg": 608,
	"./ic_paraswap.svg": 609,
	"./ic_selector_dropdowns.svg": 610,
	"./ic_settings_16.svg": 251,
	"./ic_settings_24.svg": 611,
	"./ic_sign in_16.svg": 612,
	"./ic_sign_out_16.svg": 313,
	"./ic_simpleswaps.svg": 314,
	"./ic_slingshot.svg": 613,
	"./ic_stats.svg": 315,
	"./ic_stats_big.svg": 614,
	"./ic_synapse.svg": 615,
	"./ic_telegram.svg": 616,
	"./ic_tether_24.svg": 617,
	"./ic_tokens.svg": 618,
	"./ic_totaluser.svg": 316,
	"./ic_traderjoe.png": 317,
	"./ic_trading.svg": 318,
	"./ic_transfer_avax.svg": 619,
	"./ic_twitter.svg": 319,
	"./ic_uni_24.svg": 620,
	"./ic_uni_40.svg": 621,
	"./ic_uni_arbitrum.svg": 320,
	"./ic_usdc.e_24.svg": 622,
	"./ic_usdc.e_40.svg": 623,
	"./ic_usdc_24.svg": 624,
	"./ic_usdc_40.svg": 625,
	"./ic_usdt_24.svg": 626,
	"./ic_usdt_40.svg": 627,
	"./ic_wallet_24.svg": 321,
	"./ic_wavax_24.svg": 628,
	"./ic_wavax_40.svg": 629,
	"./ic_wbtc_24.svg": 630,
	"./ic_wbtc_40.svg": 631,
	"./ic_weth_24.svg": 632,
	"./ic_weth_40.svg": 633,
	"./ic_wfuse_40.svg": 634,
	"./ic_yield_yak.png": 635,
	"./lg_arbitrum.svg": 636,
	"./logo_VLX.svg": 113,
	"./logo_VLX_small.svg": 252,
	"./long.svg": 322,
	"./metamask-text.svg": 637,
	"./metamask.png": 323,
	"./nansen_portfolio.svg": 324,
	"./page-not-found.svg": 638,
	"./position-share-bg.png": 325,
	"./short.svg": 326,
	"./swap.svg": 327,
	"./trading.jpg": 639,
	"./wallet-connect-text.svg": 640,
	"./walletconnect-circle-blue.svg": 328,
	"./wave-01.png": 641,
	"./wave-02.png": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;